import { render, staticRenderFns } from "./ProductReviewsReview.vue?vue&type=template&id=57901908&scoped=true&"
import script from "./ProductReviewsReview.vue?vue&type=script&lang=js&"
export * from "./ProductReviewsReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57901908",
  null
  
)

export default component.exports